export const equalsIgnoringCase = (text: string | undefined | null, other: string | undefined | null) => {
  if (text && other) {
    return text.localeCompare(other, undefined, { sensitivity: "base" }) === 0;
  } else {
    return text === other;
  }
};

export const containsIgnoringCase = (text: string | undefined | null, other: string | undefined | null) => {
  if (text && other) {
    return text.toLocaleLowerCase().includes(other.toLocaleLowerCase());
  } else {
    return false;
  }
};
